import { render, staticRenderFns } from "./header-layout-home.vue?vue&type=template&id=55a5afe3&scoped=true"
import script from "./header-layout-home.vue?vue&type=script&lang=js"
export * from "./header-layout-home.vue?vue&type=script&lang=js"
import style0 from "./header-layout-home.vue?vue&type=style&index=0&id=55a5afe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5afe3",
  null
  
)

export default component.exports